module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec08_b30da61667f5369c603dd4a7c866508e.jpg";